/**
 * After Odjava the browser can bring the last page back, personal data included, from its
 * back/forward cache when the user presses Back — without asking the server, so `no-store` on the API
 * responses does not stop it. A page restored that way reloads instead: the auth guard then asks the
 * server, and a logged-out user lands on the login.
 */
export function reloadOnBackForwardRestore(win: Window, reload: () => void = () => win.location.reload()): void {
  win.addEventListener('pageshow', (event: PageTransitionEvent) => {
    if (event.persisted) {
      reload();
    }
  });
}
